import React from 'react';
import { IconBack, IconHistory } from './Icons';

export const Header = ({ title, onBack, onHistory }) => (
  <div className="header">
    <button className="header-btn" onClick={onBack} style={{ visibility: onBack ? 'visible' : 'hidden' }}>
      <IconBack />
    </button>
    <span className="header-title">{title}</span>
    <button className="header-btn" onClick={onHistory} style={{ visibility: onHistory ? 'visible' : 'hidden' }}>
      <IconHistory />
    </button>
  </div>
);

export const Loader = () => (
  <div className="loader-wrap">
    <div className="spinner" />
  </div>
);

export const Modal = ({ isVisible, onClose, children }) => {
  if (!isVisible) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        {children}
      </div>
    </div>
  );
};

export const StatusBadge = ({ status }) => {
  const map = {
    Delivered: { label: 'Доставлен', cls: 'delivered' },
    OnWay: { label: 'В пути', cls: 'onway' },
    Closed: { label: 'Закрыт', cls: 'delivered' },
  };
  const s = map[status] || { label: 'Новый', cls: 'new' };
  return <span className={`status-badge ${s.cls}`}>{s.label}</span>;
};
